import Icon from "./Icon";

export default class QuestionCircle extends Icon {
  constructor() {
    super();
    this.d = `M 504 256 C 504 392.997 392.957 504 256 504 S 8 392.997 8 256 C 8 119.083 119.043 8 256 8 S 504 119.083 504 256 Z M 263 80 C 208.503 80 173.745 102.957 146 130 L 182 171 C 192 158 229 129 267 131 C 287.429 131 305 142 302 166 C 302 180.976 289.637 188.667 269.938 210.552 C 245 241 232 255 220 297 V 301 H 289 V 297 C 289 268.538 362 211 366 168 C 367 119 323 79 273 80 Z M 256 338 C 230.635 338 210 358.635 210 384 C 210 409.364 230.635 430 256 430 S 302 409.364 302 384 C 302 358.635 281.365 338 256 338 Z`;
  }
}
